module.exports = __webpack_public_path__ + "static/media/GenShinGothic-Bold.307dc661.ttf";